import React from "react";
import PersonalHeader from "../components/PersonalHeader";
import NavBarFooterDashboard from '../components/NavBarFooterDashboard';


const SelectBay = () => {

  return (
      <>
      <NavBarFooterDashboard />
      </>
  );
};
export default SelectBay;